import axios from 'axios'
import apiConfig from '../../../../../config/api-config'

const redeemLoyalty = ({ accessToken, rewardId, loyaltyCardId }) =>
  axios.post(
    `${apiConfig.apiURL}/loyalty/v1/redeem`,
    { rewardId, loyaltyCardId },
    { headers: { apikey: apiConfig.apiKey, accessToken } },
  )

export default redeemLoyalty
